import { BaseEitherError } from '@uniqkey-frontend/shared-app';

export class KeysManagerCannotDecryptPartnerPrivateKeyError extends BaseEitherError {}

export type TKeysManagerDecryptPartnerPrivateKeyOperationErrors =
  KeysManagerCannotDecryptPartnerPrivateKeyError;
